// extracted by mini-css-extract-plugin
export default {"cta":"BG-z","disabled":"CG-z"};